import { WSEmptyState, WSTable } from "@wingspanhq/fe-component-library";
import { WorkLog } from "@wingspanhq/wingspan-api-sdk";
import React, { useMemo } from "react";

import { getColumns } from "./columns";

type Props = {
  workLogs: WorkLog[];
  loading?: boolean;
  onRowOpen?: (workLogId: string) => void;
};

/**
 * The work logs covering a payroll run's pay period — the "Work logs" half of
 * the run details tabs, alongside the generated paystubs.
 */
export const TableRunWorkLogs: React.FC<Props> = props => {
  const tableData = useMemo(
    () =>
      props.workLogs.map(workLog => ({
        id: workLog.id ?? "",
        data: workLog
      })),
    [props.workLogs]
  );
  const columns = useMemo(() => getColumns(), []);

  if (!props.loading && props.workLogs.length === 0) {
    return (
      <WSEmptyState
        description="Work logs submitted for this pay period will appear here."
        title="No work logs for this pay period"
        type="documents"
      />
    );
  }

  return (
    <WSTable<WorkLog>
      columns={columns}
      loading={props.loading}
      showHeader
      tableData={tableData}
      onRowClick={
        props.onRowOpen ? item => props.onRowOpen?.(item.id) : undefined
      }
    />
  );
};
